import { CLIENT_URL } from 'utils/constants'

export const SUBSCRIPTION_PLANS = {
  FREE: {
    name: 'Free Plan'
  },
  SMALL_COMPANY: {
    name: 'Small Company'
  },
  ENTERPRISE: {
    name: 'Enterprise'
  }
}

export const PLANS_STRIPE_URLS = {
  CANCEL: `${CLIENT_URL[process.env.ENV]}/admin?menu=subscription&tab=organization&stripe=cancel`,
  SUCCESS: `${CLIENT_URL[process.env.ENV]}/admin?menu=subscription&tab=organization&stripe=success`
}
